module.exports = __webpack_public_path__ + "img/IATA_Number.97dfcbc2.svg";